function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u6587\\u5B57",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7152625,18.9846154 L15.7152625,7.82352941 L15.7152625,7.82352941 L19.2787115,7.82352941 C19.7822652,7.82352941 20.1904762,7.41531845 20.1904762,6.91176471 C20.1904762,6.40821096 19.7822652,6 19.2787115,6 L10.1022409,6 C9.59868715,6 9.19047619,6.40821096 9.19047619,6.91176471 C9.19047619,7.41531845 9.59868715,7.82352941 10.1022409,7.82352941 L13.6844933,7.82352941 L13.6844933,7.82352941 L13.6844933,18.9846154 C13.6844933,19.5453968 14.1390965,20 14.6998779,20 C15.2606593,20 15.7152625,19.5453968 15.7152625,18.9846154 Z",
  id: "T",
  fill: "#E89A4F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0879121,19.6153846 L13.0879121,4.47478992 L13.0879121,4.47478992 L17.9530812,4.47478992 C18.6364756,4.47478992 19.1904762,3.92078932 19.1904762,3.23739496 C19.1904762,2.55400059 18.6364756,2 17.9530812,2 L5.42787115,2 C4.74447678,2 4.19047619,2.55400059 4.19047619,3.23739496 C4.19047619,3.92078932 4.74447678,4.47478992 5.42787115,4.47478992 L10.3186813,4.47478992 L10.3186813,4.47478992 L10.3186813,19.6153846 C10.3186813,20.3800866 10.9385947,21 11.7032967,21 C12.4679987,21 13.0879121,20.3800866 13.0879121,19.6153846 Z",
  id: "T",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

function SvgSidebarText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6587\u5B57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarText);
export default __webpack_public_path__ + "static/media/sidebar_text.5497a0ad.svg";
export { ForwardRef as ReactComponent };